import { SkeletonElement, theme } from '@notino/react-styleguide'
import styled, { css } from 'styled-components'
import { NotinoLabelRegular400, NotinoLabelRegular500, resetButtonStyles } from '../../styles/helpers'

export const ModalHeader = styled.header`
	${NotinoLabelRegular500};
	display: flex;
	padding: 20px;
	align-items: center;
	position: relative;
`

export const ModalMain = styled.main``

export const ElementsList = styled.ul`
	width: 100%;
`

export const ElementsListItem = styled.li`
	&:not(:last-of-type) {
		border-bottom: 1px solid ${theme.color.border.divider};
	}
`

const CommonListItemStyles = css`
	${NotinoLabelRegular400};
	width: 100%;
	display: flex;
	align-items: center;
	padding: 16px 20px;
	gap: 10px;
	cursor: pointer;

	svg {
		width: 16px;
		height: 16px;
	}
`

export const ElementsListItemLink = styled.a`
	${CommonListItemStyles};
	color: ${theme.color.text.primary};
	text-decoration: none;
`

export const ElementsListItemButton = styled.button`
	${resetButtonStyles};
	${CommonListItemStyles};
`

export const ElementsListItemSkeleton = styled.div`
	${CommonListItemStyles};
`

export const ElementsListItemImageContainer = styled.div`
	width: 24px;
	height: 24px;

	img {
		aspect-ratio: 1;
		object-fit: contain;
		flex-shrink: 0;
		border-radius: 50%;
		display: block;
	}
`

export const SkeletonIconElement = styled(SkeletonElement)`
	border-radius: 50%;
`
